// Authenticated-user store. Single signal, read with currentUser().
import { createSignal } from 'solid-js';
import { api } from './api.js';
import { loadPrefs, resetPrefs } from './prefs.js';
import { loadColumnCaseMap, resetColumnCaseMap } from './columnrename.js';
import { loadFuncUsage, resetFuncUsage } from './funcusage.js';
import { forgetLock } from './lock.js';

const [currentUser, setCurrentUser] = createSignal(null);
const [authChecked, setAuthChecked] = createSignal(false);

export { currentUser, authChecked };

export const authStore = {
  async refresh() {
    try {
      const { user } = await api.get('/api/auth/me');
      setCurrentUser(user);
      if (user) { loadPrefs(); loadColumnCaseMap(); loadFuncUsage(); } // fire-and-forget
    } catch (_) {
      setCurrentUser(null);
    } finally {
      setAuthChecked(true);
    }
    return currentUser();
  },

  async login(username, password) {
    const { user } = await api.post('/api/auth/login', { username, password });
    setCurrentUser(user);
    setAuthChecked(true);
    forgetLock(); // a fresh sign-in starts unlocked (clears any stale persisted flag)
    loadPrefs(); loadColumnCaseMap(); loadFuncUsage(); // fire-and-forget
    return user;
  },

  // scope: 'device' (this device) | 'mine' (all my devices) | 'everyone'
  // (admin force-logout of all users). Returns the number of sessions ended.
  async logout(scope = 'device') {
    let count = 0;
    try { const r = await api.post('/api/auth/logout', { scope }); count = r?.count ?? 0; } catch (_) {}
    setCurrentUser(null);
    setAuthChecked(true);
    forgetLock(); // sign-out drops the lock so it can't reappear after re-login
    resetPrefs();
    resetColumnCaseMap();
    resetFuncUsage();
    return count;
  },
};
